
import React, { useState } from "react";
import DataMonitoringTabs from "./DataMonitoringTabs";
import PowerBIFrame from "./PowerBIFrame";
import DataTable from "./DataTable";
import "./dataMonitoring.css";
import OverallReport from "./OverallReport";
import { useSearchParams } from "react-router-dom";
import { REPORT_MAP } from "../../constants/Dashboard";



const DataMonitoring = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const reportFromUrl = searchParams.get("report");



  const tabFromUrl = REPORT_MAP[reportFromUrl] || 1;
  const [activeTab, setActiveTab] = useState(tabFromUrl);
  const tabNames = [
    "Data Quality Holistic",
    "Code Quality",
    "SFU Usage Metrics",
    "Cost Monitoring",
    "Platform KPI",
    "Product Usage",
    "Product View",
  ];

  const handleTabChange = (tab) => {
    const reportKey = Object.keys(REPORT_MAP).find(
      (key) => REPORT_MAP[key] === tab
    );

    setActiveTab(tab);
    setSearchParams({ report: reportKey });
  };


  const powerBiReports = [
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=da924ab7-707e-45b8-b746-f81d62b1a0b0&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
      title: "PRR and Code Rating_V1",
    },
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=75795b57-0fd3-4c32-b420-1b7e7abf69e4&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
      title: "SFU Usage Metrics",
    },
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=cb27a488-9a6d-4a0b-a8ab-f4e6459d26a4&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
      title: "Cost_Monitoring_Report",
    },
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=a952c72d-d4b3-4ddf-8532-b16fce0d5686&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
      title: "Snacking_Data_Platform_KPIs",
    },
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=a43cc5ac-0375-47a9-8416-79fd4e39cf39&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
      title: "Usage Analytics Dashboard PROD",
    },
  ];

  return (
    <div className="dm-container">
      <div className="dm-layout">
        <div className="dm-left-text">
          <h2 key={activeTab} className="tab-title-animate">
            {tabNames[activeTab - 1]}
          </h2>
        </div>
        <div className="dm-right-tabs">
          <DataMonitoringTabs activeTab={activeTab} setActiveTab={handleTabChange}
          />
        </div>
      </div>
      <div className="dm-header">  </div>

      <div className="dm-content-box">
        {activeTab === 1 ? (
          <OverallReport />
        ) : activeTab >= 2 && activeTab <= 6 ? (
          <PowerBIFrame
            url={powerBiReports[activeTab - 2].url}
            title={powerBiReports[activeTab - 2].title}
          />
        ) : (
          <DataTable />
        )}
      </div>
    </div>
  );
};

export default DataMonitoring;
